import { useToast } from "@chakra-ui/react";
import { StayUpdated } from "@kelp-dao/kernel-design-system";
import { subscribeEmail } from "@services/index";
import { EMAIL_SIGNUP } from "@constants/analytics";
import React, { useState } from "react";
import { validateEmail, trackEvent } from "utils";

const SubscribeEmail = () => {
  const [isSubscribing, setIsSubscribing] = useState(false);
  const toast = useToast();

  const handleEmailSubmit = async (email: string) => {
    if (!email || !validateEmail(email)) {
      toast({
        description: "Please enter correct email ID",
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
      return;
    }

    setIsSubscribing(true);

    const formData: any = new FormData();
    formData.append("Email", email);

    try {
      const response = await subscribeEmail(formData);

      if ((response as any).error) {
        toast({
          description: "Failed to subscribe",
          status: "error",
          duration: 2000,
          position: "top",
          isClosable: true,
        });
        setIsSubscribing(false);
        return;
      }

      toast({
        description: "Email subscribed successfully",
        status: "success",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
      trackEvent(EMAIL_SIGNUP, {
        location: "landing_page",
        success: true,
      });
    } catch (error) {
      toast({
        description: "Failed to subscribe",
        status: "error",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    } finally {
      setIsSubscribing(false);
    }
  };
  return (
    <StayUpdated
      appName="Kelp"
      body="Join 300K+ users & unlock exclusive rewards!"
      onSubmit={handleEmailSubmit}
      isLoading={isSubscribing}
      containerClassName="pb-8"
    />
  );
};

export default SubscribeEmail;
